import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {MANAGE_USER, MANAGE_USER_API_URL, GET_ALL_MANAGE_USER_API_URL} from 'constants/AppConstants';
import { USER_All_INFORMATION } from "constants/AuthConstant";
import CommonService from 'services/CommonService/CommonService';
import IntlMessage from "components/util-components/IntlMessage";
const setLocale = (localeKey, isLocaleOn = true) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();
const permission = JSON.parse(localStorage.getItem(USER_All_INFORMATION));

export const initialState = {
  ManageUserErrors       : {},
  permission: permission?.manage_user ?? [],
  ManageUserShowMessage  : null,
  ManageUserResult       : [],
  ManageUserButtonSpinner : false,
  ManageUserTableLoading : true,
  ManageUserAddDrawer    : false,
  ManageUserEditData     : [],
  ManageUserButtonAndModelLabel  : setLocale('manageuser.add'),
  tablePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
    },
    sorting: {},
    filter: {},
    ViewManageUserData: [],
    ViewManageUserLoader: true,
    DrawerStatus: 0,
};

export const createManageUser = createAsyncThunk(
    "createManageUser",
  async (data) => {
    try {
      const response = await CommonService.createAndUpdate(data, MANAGE_USER_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const getManageUser = createAsyncThunk(
    "getManageUser",
  async (data) => {
    try {
      const response = await CommonService.getAllPost(data, GET_ALL_MANAGE_USER_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const viewManageUser = createAsyncThunk(
  "viewManageUser",
  async (id) => {
    try {
      const response = await CommonService.showOne(id, MANAGE_USER_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const deleteManageUser = createAsyncThunk(
  "deleteManageUser",
  async (data) => {
    try {
      const response = await CommonService.deleteOne(data, MANAGE_USER_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const manageManageUserSlice = createSlice({
  name: MANAGE_USER,
  initialState,
  reducers: {
    onCloseError: (state, action) => {
      state.ManageUserErrors = {};
    },
    ManageUserAddDrawerStatus: (state, action) => {
        if (action.payload.status === false) {
            state.ManageUserButtonSpinner = false;
      }
      state.ManageUserAddDrawer   = action.payload.status;
      state.DrawerStatus = action.payload.errorStatus;
      state.ManageUserEditData    = [];
      state.ManageUserButtonAndModelLabel = setLocale('manageuser.add');
    },
    ManageUserEditWithDrawerStatus: (state, action) => {
      state.ManageUserAddDrawer = true;
      state.DrawerStatus = action.payload.errorStatus;
      state.ManageUserEditData = action.payload.data;
      state.ManageUserButtonAndModelLabel = setLocale('manageuser.edit');
    },
    updateSortFilters: (state, action) => {
        state.filter = action.payload.filter;
        state.sorting = action.payload.sorting;
    },
    setColumnSearch: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createManageUser.pending, (state, action) => {
        state.DrawerStatus = 0
        state.ManageUserButtonSpinner = true;
      }).addCase(createManageUser.fulfilled, (state, action) => {
        state.DrawerStatus = 0
        state.ManageUserButtonSpinner = false;
        state.ManageUserErrors = {}
      }).addCase(createManageUser.rejected, (state, action) => {
        state.DrawerStatus = 1
        state.ManageUserShowMessage = true;
        state.ManageUserButtonSpinner = false;
        state.ManageUserErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      }).addCase(getManageUser.pending, (state, action) => {
        state.ManageUserButtonSpinner = true;
        state.ManageUserTableLoading = true;
      }).addCase(getManageUser.fulfilled, (state, action) => {
        state.ManageUserButtonSpinner = false;
        state.ManageUserTableLoading = false;
        state.ManageUserResult = action.payload;
        state.tablePagination = {
            ...state.tablePagination,
            total: action.payload.pagination.total,
            current: action.payload.pagination.current_page,
            pageSize: action.payload.pagination.per_page
        };
      }).addCase(getManageUser.rejected, (state, action) => {
        state.ManageUserShowMessage = true; // Set the showMessage flag to display the errors
        state.ManageUserButtonSpinner = false;
        state.ManageUserTableLoading = false;
        state.ManageUserErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      })
      .addCase(viewManageUser.pending, (state, action) => {
        state.ViewManageUserLoader = true;
        state.ViewManageUserData = [];
      }).addCase(viewManageUser.fulfilled, (state, action) => {
        state.ViewManageUserLoader = false;
        state.ViewManageUserData = action.payload;
      }).addCase(viewManageUser.rejected, (state, action) => {
        state.ViewManageUserLoader = false;
        state.ViewManageUserData = [];
      })
      .addCase(deleteManageUser.pending, (state, action) => {
        state.ManageUserTableLoading = true;
      }).addCase(deleteManageUser.fulfilled, (state, action) => {
        state.ManageUserTableLoading = false;
      }).addCase(deleteManageUser.rejected, (state, action) => {
        state.ManageUserTableLoading = false;
      });
  },
});

export const { onCloseError, setColumnSearch, ManageUserAddDrawerStatus, ManageUserEditWithDrawerStatus, updateSortFilters } = manageManageUserSlice.actions;

export default manageManageUserSlice.reducer;